import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link as RouterLink, NavLink, useNavigate } from "react-router-dom";
import { Button, Box, Typography } from "@mui/material";
import { logout } from "../../features/auth/slice";
import "./styles.css";
import clarityLogo from "../../app/assets/images/clarity/app_logo.png";
import danaireLogo from "../../app/assets/images/danaire/app_logo.png";
import agelessindLogo from "../../app/assets/images/agelessind/app_logo.png";
import clarityDevLogo from "../../app/assets/images/clarity_dev/app_logo.png";
import froidLogo from "../../app/assets/images/froid/app_logo.png";

import config from "../../app/config";

const Header = () => {
  const { userInfo, loading } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const clientName = useSelector((state) => state.common.clientName);

  const getClientLogo = (clientName) => {
    switch (clientName) {
      case "danaire":
        return danaireLogo;
      case "agelessind":
        return agelessindLogo;
      case "clarity_dev":
        return clarityDevLogo;
      case "clarity":
        return clarityLogo;
      case "froid":
        return froidLogo;
      default:
        return null;
    }
  };

  return (
    <header>
      <div className="header-status">
        {userInfo &&
          <div className="header-logo">
            <Box
              sx={{ width: 200, resizeMode: "contain", display: "flex", alignItems: "center" }}
              component="img"
              src={getClientLogo(clientName)}
              // alt="logo"
            />
          </div>
        }
        <div className="cta">
          <span>
            {loading ? `Fetching your profile...` : userInfo !== null ? `Logged in as ${userInfo.username}` : "You're not logged in"}
          </span>
          {userInfo ? (
            <Button
              variant="contained"
              onClick={() => {
                dispatch(logout());
                navigate("/login");
              }}
              sx={{ backgroundColor: "#DAA520" }}
            >
              Logout
            </Button>
          ) : (
            <Button component={RouterLink} variant="contained" to="/login" sx={{ backgroundColor: "#DAA520" }}>
              Login
            </Button>
          )}
        </div>
      </div>
      {/* <nav className="container navigation">
        <Link component={NavLink} to="/" variant="h6">
          Last 4 years
        </Link>
        <Link component={NavLink} to="/dashboard/last-12-months" variant="h6">
          Last 12 months
        </Link>
        {!userInfo ? (
          <Link component={NavLink} to="/login" variant="h6">
            Login
          </Link>
        ) : null}
        {userInfo ? (
          <Link component={NavLink} to="/customers" variant="h6">
            Customers
          </Link>
        ) : null}
        {userInfo ? (
          <Link component={NavLink} to="/users" variant="h6">
            Users
          </Link>
        ) : null}
        {userInfo ? (
          <Link component={NavLink} to="/profile" variant="h6">
            Profile
          </Link>
        ) : null}
      </nav> */}
    </header>
  );
};

export default Header;
